import { formatKES } from '../../lib/format';

/**
 * KES price with optional struck-through compare-at price (SRS §8.4 format).
 * Prices arrive as strings over the wire to avoid float drift.
 */
export function Price({
  amount,
  compareAt,
  className = '',
  showSaveBadge = false,
  stacked = false,
  compact = false,
}: {
  stacked?: boolean;
  /** Card prices share a row where they fit and wrap without clipping on narrow cards. */
  compact?: boolean;
  amount: string;
  compareAt?: string | null;
  className?: string;
  /** Show a green "Save X%" badge next to the struck-through price (SRS v2 App. H price block). */
  showSaveBadge?: boolean;
}): JSX.Element {
  const showCompare = compareAt && Number(compareAt) > Number(amount);
  const savePct = showCompare ? Math.round((1 - Number(amount) / Number(compareAt)) * 100) : 0;
  return (
    <span
      className={`inline-flex flex-wrap ${compact ? 'gap-x-2 gap-y-0.5' : 'gap-2'} ${stacked ? 'flex-col items-start' : 'items-baseline'} ${className}`}
    >
      <span className="font-medium text-navy-900">{formatKES(amount)}</span>
      {showCompare && (
        <span
          className={`${compact ? 'text-xs' : 'text-sm'} text-neutral line-through`}
          aria-label="Original price"
        >
          {formatKES(compareAt)}
        </span>
      )}
      {showCompare && showSaveBadge && savePct > 0 && (
        <span className="rounded-full bg-success/12 px-2 py-0.5 text-xs font-medium text-green-700">
          Save {savePct}%
        </span>
      )}
    </span>
  );
}
